import React from "react";

import { useTodosContext } from "../../context/todoContext";

import Todo from "../Todo/Todo";
import TodosActions from "../TodosActions/TodosActions";

import Wrapper from "./Todos.styled";

const Todos = () => {
  const { todos } = useTodosContext();

  if (todos.length <= 0) {
    return (
      <Wrapper>
        <h2 className="empty__todos">No todos left...</h2>
        <TodosActions />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <ul className="todos__list">
        {todos.map((item, i) => (
          <Todo key={i} {...item} />
        ))}
      </ul>
      <TodosActions />
    </Wrapper>
  );
};

export default Todos;
